import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { Box, Container, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { COLORS } from '../../Constants/styles';
import { Home_IMG } from '../../Constants/ImageConstants';

const partnerPoints = [
  'Curriculum-Aligned Sports & PE',
  'Multimedia Learning Resources',
  'Digital Student Assessment',
  'Qualified Sports Professionals',
];

const LocationAndHours = () => {

  return (
    <Box
      sx={{
        px: 4,
        py: 8,
        color: COLORS.white,
        backgroundImage: `url(${Home_IMG.LocationhoursSection1})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4} alignItems="stretch" maxWidth="xl">
          {/* Why Partner With Grassroots - Left 50% */}
          <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
              style={{ flex: 1 }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  sx={{ fontFamily: "'Big Shoulders Text', sans-serif", textTransform: 'uppercase' }}
                >
                  Why Partner With Grassroots?
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
                  {partnerPoints.map((point) => (
                    <Box key={point} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <CheckCircleOutlineIcon sx={{ color: COLORS.accentLime, fontSize: 22, flexShrink: 0 }} />
                      <Typography variant="body2" sx={{ color: COLORS.white, fontWeight: 600 }}>
                        {point}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </motion.div>
          </Grid>

          {/* Who We Work With - Right 50% */}
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <Box display="flex" flexDirection="column" gap={2}>
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  sx={{ fontFamily: "'Big Shoulders Text', sans-serif", textTransform: 'uppercase' }}
                >
                  Who We Work With
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
                  {[
                    { icon: SchoolOutlinedIcon, label: 'Schools' },
                    { icon: LocalLibraryOutlinedIcon, label: 'Educational Institutions' },
                    { icon: EmojiEventsOutlinedIcon, label: 'Sports Academies' },
                    { icon: AccountBalanceOutlinedIcon, label: 'Government & NGOs' },
                    { icon: BusinessOutlinedIcon, label: 'Corporate Organizations' },
                  ].map((item) => (
                    <Box key={item.label} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <item.icon sx={{ fontSize: '1.4rem', color: COLORS.accentLime, flexShrink: 0 }} />
                      <Typography variant="body2" sx={{ color: COLORS.white, fontWeight: 600 }}>
                        {item.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box >



  );
};

export default LocationAndHours;
